/* lystia-mega-menu.js - поведінка мега-меню «Каталог» D (T-E2-14, parity/shell.md §3). Підключення: <script src defer> зі snippets/header-mega-menu.liquid.
   Значення з прототипу: показ 90 мс (mouseover), закриття 140 мс (mouseout/mouseleave/scrim), focus-visible - одразу, Esc - закрити + фокус на лінк;
   закриття також на lystia:overlay-open і lystia:device-change; закриття миттєве (без out-анімації), .is-on - у наступному кадрі. */
(function () {
  'use strict';
  if (window.__lystiaMega) return;
  window.__lystiaMega = true;

  var SHOW_MS = 90, HIDE_MS = 140;
  var MQ = window.matchMedia('(min-width: 1024px)');
  var isDesktop = function () { return document.lystia ? document.lystia.device() === 'desktop' : MQ.matches; };
  var tShow = 0, tHide = 0, scrim = null, panel = null, trigger = null;

  function findPanel() { return document.querySelector('[data-lystia-mega]'); }

  function triggerOf(el) {
    var p = el && el.closest ? el.closest('[data-lystia-mega]') : null; // панель не тригер
    if (p) return null;
    var a = el && el.closest ? el.closest('.hdr__navlink[data-path]') : null;
    var m = findPanel();
    return a && m && a.getAttribute('data-path') === m.getAttribute('data-mega-path') ? a : null;
  }

  function open() {
    clearTimeout(tHide);
    if (panel) return;
    var m = findPanel();
    if (!m || !isDesktop()) return;
    var link = null;
    document.querySelectorAll('.hdr__navlink[data-path]').forEach(function (a) {
      if (a.getAttribute('data-path') === m.getAttribute('data-mega-path')) link = a;
    });
    if (!link) return;
    panel = m; trigger = link;
    panel.hidden = false;
    scrim = document.createElement('div');
    scrim.className = 'mega-scrim';
    document.body.appendChild(scrim);
    scrim.addEventListener('mouseenter', closeSoon);
    trigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      if (panel) panel.classList.add('is-on');
      if (scrim) scrim.classList.add('is-on');
    });
  }

  function close() {
    clearTimeout(tShow); clearTimeout(tHide);
    if (trigger) trigger.removeAttribute('aria-expanded');
    if (panel) { panel.classList.remove('is-on'); panel.hidden = true; }
    if (scrim) scrim.remove();
    panel = null; scrim = null; trigger = null;
  }

  function closeSoon() {
    clearTimeout(tShow); clearTimeout(tHide);
    tHide = setTimeout(close, HIDE_MS);
  }

  function bindPanel(m) {
    if (m.__megaBound) return;
    m.__megaBound = true;
    m.addEventListener('mouseenter', function () { clearTimeout(tHide); });
    m.addEventListener('mouseleave', closeSoon);
  }

  document.addEventListener('mouseover', function (e) {
    if (triggerOf(e.target)) { clearTimeout(tHide); clearTimeout(tShow); tShow = setTimeout(open, SHOW_MS); }
  });
  document.addEventListener('mouseout', function (e) {
    if (triggerOf(e.target)) closeSoon();
  });
  document.addEventListener('focusin', function (e) {
    var a = triggerOf(e.target);
    if (a && a.matches(':focus-visible')) open();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel) {
      var a = trigger;
      close();
      if (a) a.focus();
    }
  });
  document.addEventListener('lystia:overlay-open', close);
  document.addEventListener('lystia:device-change', close);
  window.addEventListener('pageshow', close);

  function init(scope) {
    (scope || document).querySelectorAll('[data-lystia-mega]').forEach(bindPanel);
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { close(); init(e.target); });
  document.addEventListener('shopify:section:unload', close);
})();
